import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/**
 * Thin MatDialog wrapper around {@link MatchingMissingProductsSelectorComponent}. It bridges the
 * dialog's injected data to the selector's input and forwards the selector results to
 * `dialogRef.close()`, so existing modal call sites keep working unchanged.
 */
@Component({
  selector: 'app-matching-missing-ai-quote-products',
  templateUrl: './matching-missing-ai-quote-products.component.html',
  styleUrls: ['./matching-missing-ai-quote-products.component.scss'],
})
export class MatchingMissingAiQuoteProductsComponent {
  constructor(
    private dialogRef: MatDialogRef<MatchingMissingAiQuoteProductsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  onCompleted(result: any): void {
    this.dialogRef.close(result);
  }

  onCancelled(): void {
    this.dialogRef.close();
  }
}
